import { render, staticRenderFns } from "./EditMerchant.vue?vue&type=template&id=d808316c&scoped=true&"
import script from "./EditMerchant.vue?vue&type=script&lang=js&"
export * from "./EditMerchant.vue?vue&type=script&lang=js&"
import style0 from "./EditMerchant.vue?vue&type=style&index=0&id=d808316c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d808316c",
  null
  
)

export default component.exports